import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { notFound } from "~/shared/util/notFound";

export async function submissionViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { submissionId } = params ?? {};
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  if (!submissionId || !user?.id) {
    return notFound();
  }

  queryClient.prefetchQuery(USERS_QUERIES.survey(user.id?.toString(), submissionId));

  return null;
}
